/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfHoursV1TradingScheduleVersionState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_HOURS_V1_TRADING_SCHEDULE_VERSION_STATE_ENTITY_NAME = 'ixf.hours.v1.TradingScheduleVersion';
export const ixfHoursV1TradingScheduleVersionStateEntity = new schema.Entity<IxfHoursV1TradingScheduleVersionState>(IXF_HOURS_V1_TRADING_SCHEDULE_VERSION_STATE_ENTITY_NAME, {}, { idAttribute: 'tradingScheduleVersionId' });

